import { createUrl } from '@/utils/create-url'

// パンくず情報

const state = () => ({
  // パンくず情報
  list: []
})

const getters = {
  list: (state) => state.list,
  jsonld(state) {
    const list = state.list
    const items = list.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      item: {
        '@id': process.env.SITE_URL + item.url,
        name: item.name
      }
    }))
    return {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: items
    }
  }
}

const mutations = {
  list(state, list) {
    state.list = list
  }
}

const actions = {
  // パンくず情報セット
  list({ commit }, list) {
    commit('list', list)
  },

  // 検索一覧ページ用パンくずリスト生成
  searchpage({ dispatch }, { query, url = 's' }) {
    let pageName = 'セミナー会場'
    if (url === 'summary') {
      pageName = 'イベント会場まとめ'
    }
    const list = [
      { name: 'ホーム', url: '/' },
      { name: pageName, url: `/${url}/` }
    ]

    const params = {}
    if (query && query.eventTag) {
      params.eventTag = query.eventTag
      list.push({
        name: query.eventTag,
        url: createUrl.createSearchUrl(params)
      })
    }
    if (query && query.keyword) {
      params.keyword = query.keyword
      list.push({
        name: query.keyword,
        url: createUrl.createSearchUrl(params)
      })
    }

    if (query && query.prefecture) {
      params.prefecture = query.prefecture
      list.push({
        name: query.prefecture,
        url: createUrl.createSearchUrl(params)
      })

      if (query && query.city) {
        params.city = query.city
        list.push({
          name: query.city,
          url: createUrl.createSearchUrl(params)
        })
      }
    }

    dispatch('list', list)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
